/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { CrewConstants } from '../store/crew.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPCRCrewSelector } from '../../crew/selectors/getPCRCrew.selector'
import { IPCRCrewMember, IPCRCrewMemberList } from '../../crew/store/crew.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import Logger from '../../../services/logger.service'

export function* setCrewList() {
  const pcrId = yield select(getPcrIdSelector)

  if (pcrId) {
    const serviceId = yield select(getServiceIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    try {
      const pcr: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
      const pcrCrew: IPCRCrewMemberList = yield select(getPCRCrewSelector)
      if (pcr) {
        pcr.crew = pcrCrew.filter((crewMember: IPCRCrewMember) => crewMember.user !== null)
        yield call([pcrDocsService, pcrDocsService.savePCR], pcr)
        const crewUserIds = pcr.crew?.map((crew) => crew.user?.id).join(', ')

        Logger.info(`PCR: ${pcrId} created with crew: ${crewUserIds}`)
      }
    } catch (e) {
      yield put(throwPcrException(`saveCrewList() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCrewListSaga() {
  yield takeLatest([CrewConstants.SET_CREW_LIST], performWithMutexHOG, setCrewList)
}
